<script setup>
defineProps({
  blocco: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="image-text-block row-120-20 max p-bot-1">
    <div
      v-if="blocco.landscape && blocco.landscape.responsiveImage"
      class="left"
    >
      <div class="img-container">
        <DefaultPicture
          class="show-for-large"
          :image="{ landscape: blocco.landscape.responsiveImage }"
          :lazy-load="true"
          alt="DigitXS"
        />
      </div>
      <div class="img-container">
        <DefaultPicture
          class="hide-for-large"
          :image="{ portrait: blocco.portrait.responsiveImage }"
          :lazy-load="true"
          alt="DigitXS"
        />
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="right">
      <h2 v-if="blocco.titolo" class="heading-1 title" v-html="blocco.titolo" />
      <div
        v-if="blocco.testo"
        class="text-2 section-text"
        v-html="blocco.testo"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
